<template>
<div>
    <div class="bgp" style="text-align: center; text-shadow: 1px 1px 2px #333;">
        <h1 style="color: white; padding-top: 10px; padding-top: 170px;">{{ $t('conH') }}</h1>
        <p style="color: white; padding-top: 10px;">{{ $t('conP') }}</p>
    </div>
    <div class="container" style="padding-top: 70px; padding-bottom: 70px;">
    <form action="https://formsubmit.co/info@protel.ge" method="POST">
    <div class="row">
      <div class="col-xl-6 col-md-6 col-sm-12 ">
        <div>
          <p style="font-weight: 550;  margin-top: 15px;">{{ $t('name') }}</p>
          <b-form-input v-model="name"  name="name" style="border: none; box-shadow: 0px 10px 20px 2px #bbb8b8;" placeholder="Enter your name"></b-form-input>
        </div>
        <div>
          <p style="font-weight: 550; margin-top: 15px;">{{ $t('email') }}</p>
          <b-form-input :state="emailValid"  name="email" type="email" v-model="email" style="border: none; box-shadow: 0px 10px 20px 2px #bbb8b8;" placeholder="Enter your e-mail"></b-form-input>
        </div>
      </div>
      <div class="col-xl-6 col-md-6 col-sm-12 ">
        <p style="font-weight: 550; margin-top: 15px; ">{{ $t('desc') }}</p>
        <b-form-textarea
        name="text"
        style="border: none; box-shadow: 0px 10px 20px 2px #bbb8b8;"
        id="textarea"
        v-model="text"
        placeholder="Please describe your request in detail"
        rows="5"
        max-rows="8"
        ></b-form-textarea>
      </div>
    </div>
    <input v-if="emailValid && name.length > 0 && text.length > 0" style="background: #b72027; font-weight: 600; border: none; font-size: 15px; margin-top: 15px; padding: 8px 20px 8px 20px; color: white; letter-spacing: 1.5px;" type="submit" value="SEND">
    <b-button v-else disabled style="background: #b72027; font-weight: 600; border: none; font-size: 15px; margin-top: 15px; padding: 8px 20px 8px 20px; border-radius: 0px; letter-spacing: 1.5px;"> {{ $t('send') }} </b-button>
    </form>

  </div>
</div>
</template>

<script>
// import emailjs from 'emailjs-com';

  export default {
  name: 'Contact',
  metaInfo: {
    title: 'Contact',
  },
    data() {
      return {
        email: '',
        name: '',
        text: '',
        show: true,
      }
    },
    methods: {
      
    },
   computed: {
      emailValid() {
        return this.email.includes("@") ? true : false
      }
    },

  }
</script>

<style scoped>
.bgp{
background-image: url("../assets/att.jpg");
background-size: cover;
height: 400px;
}
.center {
margin-left: 45%;
padding-top: 200px;
color: white;
}


</style>
